import { useMemo } from 'react'
import cn from 'clsx'

const useClassName = (
  ...classes: Array<string | number | Record<string, boolean> | undefined>
): string => useMemo((): string => cn(...classes), [...classes])

export default useClassName
